import { ChevronRight } from 'lucide-react-native';
import { iconWithClassName } from './iconWithClassName';

iconWithClassName(ChevronRight);
export { ChevronRight };
